import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import { useContext, useState } from 'react';
import { AppContext } from 'context/app-context';
import { setModal } from 'store/features/modelSlice';
import { initModal } from 'helpers/utils';
import PrimaryDarkButton from 'components/common/buttons/primary-dark-btn';
import DarkButton from 'components/common/buttons/dark-btn';
import InputField from 'components/common/input-field';
import { ReactComponent as CrossIcon } from 'assets/icon/x-circle.svg';
import { createEngine, updateEngine } from 'store/features/vehicleConfigSlice';
import toast from 'react-hot-toast';
import { IEngine } from 'interfaces/vehicle-config-interfaces';
import { useTranslation } from 'react-i18next';

const AddEditEngine = () => {
  const dispatch = useAppDispatch();
  const {
    modal: {
      content: { title, formFor, callBackFun },
    },
  } = useAppSelector(state => state.modal);
  const { selectedEngine } = useAppSelector(state => state.vehicleConfig);
  const { setLoader } = useContext(AppContext);
  const [engine, setEngine] = useState<IEngine>(
    formFor === 'EDIT' && selectedEngine ? selectedEngine : { name: '' },
  );
  const [error, setError] = useState<string>('');
  const { t } = useTranslation();
  const handleAddEngine = async () => {
    try {
      setLoader(true);
      await dispatch(createEngine({ name: engine?.name }))
        .then(() => {
          callBackFun && callBackFun();
          toast.success(t('workshopAppointment.succesEngineAddedToastMessage'));
          dispatch(setModal(initModal));
          setLoader(false);
        })
        .catch(() => {
          setLoader(false);
        });
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };
  const handleEditEngine = async () => {
    try {
      setLoader(true);
      await dispatch(
        updateEngine({
          engine_id: engine._id || '',
          request: { engine_id: engine?._id || '', name: engine?.name },
        }),
      )
        .then(() => {
          callBackFun && callBackFun();
          toast.success(t('workshopAppointment.succesEngineUpdatedToastMessage'));
          dispatch(setModal(initModal));
          setLoader(false);
        })
        .catch(() => {
          setLoader(false);
        });
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };
  const handleSubmit = () => {
    try {
      if (!engine?.name?.trim()) {
        setError(t('workshopAppointment.errorEngineToastMessage'));
        return;
      }
      formFor === 'EDIT' ? handleEditEngine() : handleAddEngine();
    } catch (error) {
      setLoader(false);
    }
  };
  return (
    <div className="flex flex-wrap max-w-[450px] w-[450px] gap-y-4 overflow-hidden">
      <div className="flex items-center w-full">
        <div className="flex items-center flex-1">
          <label className="pl-2 text-xl font-semibold text-black2">{title}</label>
        </div>
        <div
          className="flex items-center justify-center cursor-pointer"
          onClick={() => dispatch(setModal(initModal))}
        >
          <CrossIcon height={32} width={32} />
        </div>
      </div>
      <div className="flex flex-wrap w-full overflow-y-auto max-h-[calc(100vh- 200px)] gap-y-1">
        <div className="w-full">
          <label className="font-medium text-xs text-black2 w-full">
            {t('workshopAppointment.engine')}
          </label>
          <InputField
            onChange={data => setEngine({ ...engine, name: data })}
            error={error}
            value={engine.name}
            placeholder={t('workshopAppointment.enginePlaceholder')}
          />
        </div>
      </div>
      <div className="flex items-center justify-center w-full gap-x-4 mt-4">
        <PrimaryDarkButton
          label={
            formFor === 'EDIT'
              ? t('workshopAppointment.saveChanges')
              : t('workshopAppointment.addEngine')
          }
          onClick={() => handleSubmit()}
          width="w-1/3"
        />
        <DarkButton
          label={t('CANCEL')}
          width="w-1/3"
          onClick={() => dispatch(setModal(initModal))}
        />
      </div>
    </div>
  );
};

export default AddEditEngine;
